module.exports = __webpack_public_path__ + "static/img/zxyt-details.8dfbeff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zxyt-details.png
// module id = 7znx
// module chunks = 0